import { environment } from "@env/environment";

export namespace LogHelper {

	export function log(...values): void {

		if (environment.activeConsoleLog) {
			console.log(values);
		}
	}
}
